import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { client, urlFor } from "../sanity";
import "../Styles/OptionDetails.css";
import BookingFormModal from "./BookingFormModal";

const OptionDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const [vehicle, setVehicle] = useState(location.state || null);
  const [mainImage, setMainImage] = useState("");
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const fetchVehicle = async () => {
      if (!vehicle) {
        const query = `*[_type == "vehicle" && _id == $id][0]{
          _id, name, description, price, rating, image, imageGallery,
          type, make, color, category, interiorOptions, services
        }`;
        const data = await client.fetch(query, { id });
        setVehicle(data);
      }
    };
    fetchVehicle();
  }, [id, vehicle]);

  useEffect(() => {
    if (vehicle?.image) {
      setMainImage(urlFor(vehicle.image));
    } else if (vehicle?.imageGallery?.length > 0) {
      setMainImage(urlFor(vehicle.imageGallery[0]));
    }
  }, [vehicle]);

  if (!vehicle) return <h2>Loading vehicle details...</h2>;

  const galleryUrls = (vehicle.imageGallery || []).map(img => urlFor(img));
  const mainImageUrl = mainImage;

  return (
    <div className="details-page">
      {/* LEFT SIDE */}
      <div className="details-left">
        {/* IMAGE GALLERY */}
        <div className="gallery">
          <div className="main-image">
            <img src={mainImage} alt={vehicle.name} />
          </div>
          <div className="thumbs">
            {galleryUrls.filter(url => url !== mainImageUrl).slice(0, 3).map((url, i) => (
              <img
                key={i}
                src={url}
                alt={`${vehicle.name}-${i}`}
                onClick={() => setMainImage(url)}
                className={mainImageUrl === url ? "active-thumb" : ""}
              />
            ))}
          </div>
        </div>

        {/* OVERVIEW */}
        <div className="overview">
          <h2>{vehicle.name} Overview</h2>
          <p>{vehicle.description}</p>
        </div>

        {/* SERVICES OFFERED */}
        <div className="services">
          <h2>Services Offered</h2>
          <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo laborum consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla est pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id.</p>
          <ul>
            {vehicle.services?.map((srv, i) => (
              <li key={i}>✔ {srv.replace(/-/g, " ")}</li>
            ))}
          </ul>
        </div>

        {/* EXTRA IMAGE */}
        <div className="extra-image">
          <img
            src="https://luxedrive.qodeinteractive.com/wp-content/uploads/2023/01/Vihecle-single-content-image-.jpg"
            alt="extra"
          />
        </div>

        {/* COMMENTS */}
        <div className="comments">
          <h3>2 Comments</h3>
          <div className="comment">
            <strong>Daniel James</strong>
            <p>I rented this car last weekend, and the experience was flawless! Smooth ride, spotless interior, 
      and the pickup process was super easy. Definitely booking again.</p>
          </div>
          <div className="comment">
            <strong>Samuel Tobi</strong>
            <p>The comfort level is unmatched. It felt like driving pure luxury — from the leather seats to the 
      sound system. Worth every penny.</p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="details-right">
        <img
          src="https://luxedrive.qodeinteractive.com/wp-content/uploads/2023/01/Vihecle-single-corner-img-.png"
          alt={vehicle.name}
          className="option-image"
        />
        <h2>{vehicle.name}</h2>
        <p>{vehicle.type} | {vehicle.make} | {vehicle.color} | {vehicle.category}</p>

        {/* EXTRAS TILES */}
        <h3 className="extra-tile-h3">Extras</h3>
        <div className="extras-tiles">
          {vehicle.interiorOptions?.map((opt, i) => (
            <div key={i} className="extra-tile">
              {opt.replace(/-/g, " ")}
            </div>
          ))}
        </div>

        {/* PRICE */}
        {/* <h3>Price</h3> */}
        {/* <p><strong>{vehicle.price}</strong></p> */}

        <button className="book-btn" onClick={() => setShowForm(true)}>
          <span className="plus-icon">+</span> Book Ride
        </button>

      </div>

      <BookingFormModal
        show={showForm}
        onClose={() => setShowForm(false)}
        prefill={{ carName: vehicle.name }}
        includeCarName={true}
      />;
    </div>
  );
};

export default OptionDetails;
